import EfSpec from '@elem/ui/ef-spec';
import { Collapse } from 'antd-v5';
import { useCallback, useEffect, useRef, useState } from 'react';
import { useRouter } from 'next/router';
import EfLink from '@elem/ui/ef-link';
import ModuleTabs from '../../components/ModuleTabs';
import { LearnMoreList } from '../../common';
import css from './index.module.scss';
import { D_DATA } from './common';
import { getFaqCatagoryTree, getFaqs } from '@/service';

export default function D() {
    const { locale = 'us' } = useRouter();
    const { moduleTitle } = (D_DATA[locale] || D_DATA['us']) ?? {};
    const contentRef = useRef<HTMLDivElement>(null);

    const [currentTab, setCurrentTab] = useState('');
    const [tabs, setTabs] = useState<
        {
            label: string;
            value: string;
            productCatagoryIds: string;
            spuIds: string;
        }[]
    >([]);
    const [allFaq, setAllFaq] = useState<{
        [key: string]: {
            title: string;
            description: string;
        }[];
    }>({});

    const getFAQ = useCallback(async () => {
        try {
            const categoryTreeRes = await getFaqCatagoryTree(locale);
            const curTabs = categoryTreeRes.data.map((i: any) => {
                const productCatagoryIds: string[] = [];
                const spuIds: string[] = [];

                const pushIds = (i: any) => {
                    if (i.subs && i.subs.length > 0) {
                        productCatagoryIds.push(i.faqCatagoryId);
                    } else {
                        spuIds.push(i.faqCatagoryId);
                    }

                    i?.subs?.forEach?.((j: any) => pushIds(j));
                };
                pushIds(i);
                return {
                    label: i.name,
                    sort: i.sort,
                    value: i.faqCatagoryId,
                    productCatagoryIds: productCatagoryIds.join(','),
                    spuIds: spuIds.join(','),
                };
            }) as any[];
            const tabs = [...curTabs].sort((a: any, b: any) => a.sort - b.sort);
            setTabs(tabs);
            setCurrentTab(categoryTreeRes.data[0].faqCatagoryId);

            const faqs = tabs.map(async (i) => {
                const { productCatagoryIds = '', spuIds = '' } = i;
                let faq: any[] = [];
                const params: { [key: string]: any } = { size: 5 };

                if (productCatagoryIds) {
                    params.productCatagoryIds = productCatagoryIds;
                } else {
                    params.spuIds = spuIds;
                }

                try {
                    const res = await getFaqs(params);
                    if (res?.data?.content?.length > 0) {
                        faq = res.data.content;
                    } else {
                        const j = await getFaqs({ spuIds, size: 5 });
                        faq = j.data.content;
                    }
                } catch (err) {}

                return {
                    faqCatagoryId: i.value,
                    faq,
                };
            });
            Promise.all(faqs).then((res) => {
                const obj: { [key: string]: any } = {};
                res.forEach((i) => {
                    obj[i.faqCatagoryId] = i.faq;
                });

                setAllFaq(obj);
            });
        } catch (error) {}
    }, [locale]);

    useEffect(() => {
        getFAQ();
    }, [getFAQ, locale]);

    return (
        <div className={`support-module ${css['Support']}`} ref={contentRef}>
            <EfSpec />
            <div className="support-title">{moduleTitle}</div>
            <ModuleTabs list={tabs} value={currentTab} contentRef={contentRef} onChange={setCurrentTab} />
            <div>
                <Collapse ghost={true} className="FAQ-container" defaultActiveKey={0} expandIconPosition="right">
                    {allFaq[currentTab]?.map?.((item, k: number) => (
                        <Collapse.Panel className="list-title" key={k} header={item.title}>
                            <div dangerouslySetInnerHTML={{ __html: item.description }} />
                        </Collapse.Panel>
                    ))}
                </Collapse>
            </div>
            <EfLink
                className="support-link support-more"
                href="support/faq"
                dataLayer={[
                    {
                        event: 'uaEvent',
                        event_name: 'view_more',
                        list_name: moduleTitle,
                        button_name: LearnMoreList[locale],
                    },
                ]}
            >
                {`${LearnMoreList[locale]} >`}
            </EfLink>
        </div>
    );
}
